// optimonk top bar mods to stick above header
var OptiMonkOnReady = function () {
let counter = 0;
const interval = setInterval(() => {
  // Run your check code here
  var navHeight = $('.om-container[style*="display: block"] .nanobar .om-outer-canvas').outerHeight();
  if (navHeight > 0) {
    $('#shopify-section-header').css('top', navHeight);
    clearInterval(interval);
  }
  // console.log('running om check');
  counter++;
  if (counter >= 150) {
    clearInterval(interval); // Stop the interval if nothing is found after 15 seconds (150 * 100ms)
  }
}, 100);
};

$(window).resize(function () {
  var OptiMonkOnReady = function () {
let counter = 0;
const interval = setInterval(() => {
  // Run your check code here
  var navHeight = $('.om-container[style*="display: block"] .nanobar .om-outer-canvas').outerHeight();
  if (navHeight > 0) {
    $('#shopify-section-header').css('top', navHeight);
    clearInterval(interval);
  }
  // console.log('running om check');
  counter++;
  if (counter >= 150) {
    clearInterval(interval); // Stop the interval if nothing is found after 15 seconds (150 * 100ms)
  }
}, 100);
};
});

/// end optimonk updates

var owl_home_video = $('#owl_home_video');
owl_home_video.owlCarousel({
  items: 3,
  lazyLoad: true,
  nav: true,
  margin: 15,
  navElement: 'div',
  navText: [
    '<i class="fa fa-angle-left"></i>',
    '<i class="fa fa-angle-right"></i>',
  ],
  dots: false,
  responsive: {
    0: {
      nav: true,
      items: 1,
    },
    600: {
      nav: false,
      items: 3,
    },
    1000: {
      nav: false,
      items: 3,
    },
  },
});

var reviewCarousel = $('#owl-review');
reviewCarousel.owlCarousel({
  items: 3,
  lazyLoad: true,
  margin: 10,
  nav: true,
  navText: [
    '<i class="fa fa-angle-left"></i>',
    '<i class="fa fa-angle-right"></i>',
  ],
  navElement: 'div',
  dots: false,
  responsive: {
    0: {
      items: 1,
    },
    480: {
      items: 2,
    },
    768: {
      items: 3,
    },
  },
});

$('#slick_collection').slick({
  dots: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow:
    '<div class="slick-next"><i class="fa fa-angle-right"></i></div>',
  prevArrow:
    '<div class="slick-prev"><i class="fa fa-angle-left"></i></div>',
  responsive: [
    {
      breakpoint: 950,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$('#slick_collection .slick-prev.slick-arrow').hide();
$('#slick_collection .slick-next.slick-arrow').click(function () {
  $('#slick_collection .slick-prev.slick-arrow').show();
});

var settings = {
  dots: false,
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  nextArrow: '<div class="slick-next"></div>',
  prevArrow: '<div class="slick-prev"></div>',
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

var settingsNew = {
  dots: false,
  infinite: false,
  slidesToShow: 4.5,
  slidesToScroll: 1,
  lazyLoad: 'ondemand',
  nextArrow: '<div class="slick-next"></div>',
  prevArrow: '<div class="slick-prev"></div>',
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
  ],
};

var settingsNew3 = {
  dots: false,
  infinite: false,
  slidesToShow: 3.5,
  slidesToScroll: 1,
  lazyLoad: 'ondemand',
  nextArrow: '<div class="slick-next"></div>',
  prevArrow: '<div class="slick-prev"></div>',
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
  ],
};

$('#new-review-container').slick({
  dots: true,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: '<div class="slick-next"></div>',
  prevArrow: '<div class="slick-prev"></div>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$('.meet-jack-carousel').slick({
  dots: true,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: '<div class="slick-next"></div>',
  prevArrow: '<div class="slick-prev"></div>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
$('.newindex-three-columns').slick({
  dots: true,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: '<div class="slick-next"></div>',
  prevArrow: '<div class="slick-prev"></div>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$('#confidence-item-container').slick({
  dots: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: '<div class="slick-next"></div>',
  prevArrow: '<div class="slick-prev"></div>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

/*$(".colorway-slider").slick({
  dots: true,
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  nextArrow: '<div class="slick-next"></div>',
  prevArrow: '<div class="slick-prev"></div>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
});*/

$(document).ready(function () {
  var oldColor = $('.variant-pro-color').text();
  $('.colorway-slider .primary-image a').hover(
    function () {
      var proColor = $(this).attr('data-color');
      $('.variant-pro-color').text(proColor);
    },
    function () {
      $('.variant-pro-color').text(oldColor);
    }
  );

  // new legacies slider
  var legSettings = {
    dots: false,
    infinite: false,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    nextArrow:
      '<div class="slick-next"><i class="fa fa-angle-right"></i></div>',
    prevArrow:
      '<div class="slick-prev"><i class="fa fa-angle-left"></i></div>',
    responsive: [
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  $('#leg_slider').slick(legSettings);

  //end legacies slider

  var mobileNvaHtml =
    '<div id="main-nav" class="nav-row mobile_view">' +
    $('#main-nav').html() +
    '</div>';
  $('.mobile-navigation').html(mobileNvaHtml);

  if (window.location.search.match('out-of-stock')) {
    setTimeout(function () {
      $('.klaviyo-bis-trigger').trigger('click');
    }, 300);
  }

  $('.myBtn').click(function (e) {
    e.preventDefault();
    var src1 = $(this).data('src');
    $('#myModal .modal-content iframe').attr('src', src1);
    $('#myModal').show();
    var w_height = $(window).height();
    var modal_height = $('.modal-content').height();
    var margin = (w_height - modal_height) / 2;
    $('.modal-content').css('margin-top', margin);
  });

  $('#myModal .close').click(function () {
    $('#myModal').hide();
    $('#myModal .modal-content iframe').attr('src', '');
  });

  $('.icemanBtn').click(function (e) {
    e.preventDefault();
    var src1 = $(this).data('src');
    $('#iceManModal .modal-content iframe').attr('src', src1);
    $('#iceManModal').show();
    var w_height = $(window).height();
    var modal_height = $('#iceManModal .modal-content').height();
    var margin = (w_height - modal_height) / 2;
    $('#iceManModal .modal-content').css('margin-top', margin);
  });

  $('#iceManModal .close').click(function () {
    $('#iceManModal').hide();
    $('#iceManModal .modal-content iframe').attr('src', '');
  });

  if ($(window).width() > 767) {
    /* var img_h = $('.discover-collection .item img').height();
    var div_h = $('.explore-left').height();
    var dif_h = (img_h - div_h)/2;
    $('.explore-left').css('margin-top', dif_h);
	*/

    var mtxtH = $('.minsonary-left-top-left.mtext').height();
    var mtxtInner = $(
      '.minsonary-left-top-left.mtext > div'
    ).height();
    var margin = (mtxtH - mtxtInner) / 2;
    $('.minsonary-left-top-left.mtext > div').css(
      'margin-top',
      margin
    );

    var mtxtH2 = $('.minsonary-right-bottom.mtext').height();
    var mtxtInner2 = $(
      '.minsonary-right-bottom.mtext > div'
    ).height();
    var margin2 = (mtxtH2 - mtxtInner2) / 2;
    $('.minsonary-right-bottom.mtext > div').css(
      'margin-top',
      margin2
    );

    /*-----------------new navigation ------------*/
    $('.tier-1 li.level1').hover(
      function () {
        $(this)
          .find('.explore-subnav li.level2:first .list-item:first')
          .addClass('active');
        $(this)
          .find('.explore-subnav li.level2:first')
          .addClass('active');
      },
      function () {
        $(this)
          .find('.explore-subnav li.level2:first .list-item:first')
          .removeClass('active');
        $('.tier-1 li.level1 li.level2').removeClass('active');
        $('.tier-1 li.level1 li.level2 .list-item').removeClass(
          'active'
        );
      }
    );

    $('.tier-1 li.level1 li.level2').hover(function () {
      $('.tier-1 li.level1 li.level2').removeClass('active');
      $('.tier-1 li.level1 li.level2 .list-item').removeClass(
        'active'
      );
      $(this).addClass('active');
      $(this).find('.list-item:first').addClass('active');
    });

    $('.tier-1 li.level1 li.level2 .list-item').hover(function (e) {
      //e.stopPropagation();
      $('.tier-1 li.level1 li.level2 .list-item').removeClass(
        'active'
      );
      $(this).addClass('active');
    });

    /*------------new navigation end ------------*/
  }

  $(document).on(
    'click clickinstant',
    '.sub-menu-heading-mobile.is-subnav',
    function (e) {
      var navAnimSpeed = 200;
      if (e.type == 'clickinstant') {
        navAnimSpeed = 0;
      }
      var w_width = $(window).width();
      if (w_width <= 767) {
        var obj = $(this);
        if ($(this).parent().hasClass('expanded')) {
          $(this)
            .next()
            .slideUp(navAnimSpeed, function () {
              $(this).parent().removeClass('expanded');
              obj.removeClass('opened');
            });
        } else {
          $(this)
            .next()
            .slideDown(navAnimSpeed, function () {
              obj.addClass('opened');
              $(this).parent().addClass('expanded');
            });
        }
        var topOffset = obj.offset().top - 150;
        $('#main-nav').animate(
          {
            scrollTop: topOffset,
          },
          'slow'
        );
      }

      return false;
    }
  );

  $('.footer-nav h6').on('click', function () {
    $(this).toggleClass('active');
    $(this).parent().find('ul').toggleClass('open');
  });

  if ($(window).width() > 767) {
    $('.gift-row-container .gift-row').each(function () {
      var imgHeight = $(this).find('.row-big').height();
      var rowSmallHeight = $(this).find('.row-small').height();
      var marginTop = (imgHeight - rowSmallHeight) / 2;
      if (marginTop > 1) {
        $(this).find('.row-small').css('margin-top', marginTop);
      } else {
        $(this).find('.row-small').css('margin-top', 20);
      }
    });
  }

  //product image mobile slider
  $('.product_images_slider').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  });

  //for all tabs
  $('ul.tabs li').click(function () {
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $('#' + tab_id).addClass('current');
  });

  $('#nl_submit').on('click', function () {
    var subsEmail = $('#mce-EMAIL').val();
    window.letterpress('trackUnstructEvent', {
      schema: 'iglu:com.getletterpress/email/jsonschema/1-0-0',
      data: {
        email: subsEmail,
      },
    });

    $('#mc-embedded-subscribe-form').submit();
  });

  /*------------- footer currency switcher ------------*/

  /*$('.footer-shop-currency').on('click', function(){
    $(this).toggleClass('active');
    $(this).parent().find('.footer-currencies').slideToggle('slow');
  });

  var currentCurrency = Currency.currentCurrency;
  var currentCurrencyImg = "";

  $('#footer_currencies li').each(function(){
    if($(this).attr('data-value') == currentCurrency){
      currentCurrencyImg = $(this).find('img').attr('src');
    }
  });

  $('#footer_currencies li[data-value="'+currentCurrency+'"]').addClass('current');

  $('.footer-shop-currency img').attr('src',currentCurrencyImg);

  $('#footer_currencies li').on('click', function(){
    var dataVal = $(this).attr('data-value');
    var imgSrc = $(this).find('img').attr('src');
    var dt_indx = $(this).index();
    //alert(dt_indx);
    $('#currencies option[value='+dataVal+']').prop("selected",true);
    //$('#currencies').val(dataVal);
    $('#currencies').val(dataVal).trigger('change');
    //document.getElementById('currencies').value = dataVal;
    $('.footer-shop-currency img').attr('src', imgSrc);
    $('.footer-currencies').slideUp();
    $('#footer_currencies li').removeClass('current');
    $(this).addClass('current');
  });*/
  /*----------------footer currency switcher end --------*/
});

$(window).click(function (event) {
  var modal = document.getElementById('myModal');
  if (event.target == modal) {
    $('#myModal').hide();
    $('.modal-content iframe').attr('src', '');
  }
});

/*---------------- cart page -------------------*/
$(window).on('load', function () {
  $('.additional-checkout-button--paypal-express').after('<br>');
  if ($('.flexslider').length) {
    $('.flexslider').flexslider({
      animation: 'fade',
      slideshow: $(this).hasClass('auto-play'),
      prevText: '&lsaquo;',
      nextText: '&rsaquo;',
      smoothHeight: true,
      directionNav: true,
      slideshowSpeed: 7000,
      after: function () {
        var current = $('.strapSlide li.flex-active-slide');
        var xx = current.find('div').attr('data-id');
        $('.cart_product').each(function () {
          $(this).hide();
        });
        $('.cart_product_' + xx).show();
      },
    });
  }
});

$(document).ready(function () {
  $('.xtra-strap').on('click', function () {
    $('.strapSlide,.parent_Slide_content').toggle();
  });
  jQuery(
    '.MagicToolboxContainer .MagicToolboxSelectorsContainer li[data-vid="25929884878"] a'
  ).trigger('click');

  $('.swatch-container-collection a').on('click', function (e) {
    e.preventDefault();
    var img = $(this).attr('data-image');
    var id = $(this).attr('data-id');
    var cart = $(this).attr('data-cart');
    var avail = $(this).attr('data-avail');
    $(this).parent().parent().find('.productImage').attr('src', img);
    $(this).parent().parent().find('form input[name="id"]').val(id);
    $(this).parent().parent().find('form button').text(cart);
    if (avail == 'Unavailable') {
      $(this).parent().parent().find('.klaviyo-notify').show();
      $(this).parent().parent().find('form button').hide();
    } else {
      $(this).parent().parent().find('.klaviyo-notify').hide();
      $(this).parent().parent().find('form button').show();
    }
  });
});

$(document).on('ready page:load page:change', function () {
  var giftChild = [];
  var giftPrice = 0;
  $('#cartform li.item').each(function () {
    if ($(this).data('id') == '12470290055285') {
      $(this)
        .find('.name-container .custom')
        .each(function () {
          if ($(this).text() != '') {
            var txt = $(this).text();
            txt = txt.replace('Watch:', '');
            txt = txt.replace('Strap:', '');
            txt = $.trim(txt);
            giftChild.push(txt);
          }
        });
    }
  });

  $('#cartform li.item').each(function () {
    var obj = $(this);
    var proId = obj.data('id');
    if ($.inArray(proId.toString(), giftChild) != -1) {
      obj.addClass('giftChild');
      var priceTxt = $(this).find('.line-total .money').text();
      priceTxt = parseFloat(priceTxt.replace('$', ''));
      giftPrice = parseFloat(giftPrice) + parseFloat(priceTxt);
    }
  });

  $('.customizable-gift-box')
    .find('.discounted_price .money')
    .text('$' + giftPrice.toFixed(2));
});

$('document').ready(function () {
  function removeItem(t, r) {
    var e = {
      async: false,
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&id=' + t,
      dataType: 'json',
      success: function (t) {
        //"function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
      },
    };
    jQuery.ajax(e);
  }
  $('#cartform .remove').on('click', function (e) {
    e.preventDefault();
    var obj = $(this);
    $('#cartform li.item').each(function () {
      if ($(this).hasClass('giftChild')) {
        //$(this).find('.remove').trigger('click');
        var id = $(this).data('id');
        removeItem(id);
      }
    });
    window.location.href = obj.attr('href');
  });

  $('.blog-tab .tab-item').click(function () {
    var tab_id = $(this).attr('data-tag');

    $('.blog-tab .tab-item').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $('#' + tab_id).addClass('current');
  });
});

if ($('.layout-column-half-right').length) {
  $.initialize(
    '.layout-column-half-right .yotpo-bottomline a.text-m',
    function () {
      var x = $(this).html();
      //     if(x == '1 Review') {
      //       $('.yotpo').hide();
      //     } else if (x == '2 Reviews') {
      //       $('.yotpo').hide();
      //     } else if (x == 'Write a review') {
      //       $('.yotpo').hide();
      //     }
    }
  );
}

$(document).on('click', '.out_of_stock_button1', function () {
  $.fancybox({
    content: $('#back-in-stock-modal-container').html(),
    autoSize: false,
    margin: 60,
  });
  return false;
});

$(document).on('click', '.icon-info', function () {
  $.fancybox({
    content: $('#size_guide_modal_content').html(),
    autoSize: false,
    padding: 0,
  });
  return false;
});

$('body').on(
  'click',
  '.size-guide-button-container .size-btn',
  function () {
    var imageClass = $(this).attr('data-image');
    $('.size-guide-button-container .size-btn').removeClass('active');
    $('.size-guide-image-container .size-image').removeClass(
      'active'
    );
    $(this).addClass('active');
    $('.size-guide-image-container .' + imageClass).addClass(
      'active'
    );
  }
);

$('.hero-video').fancybox({
  content: $('#fancybox-content').html(),
  width: 1200,
  height: 800,
  fitToView: false,
  autoSize: false,
  autoDimensions: false,
  closeClick: false,
  type: 'iframe',
  openEffect: 'none',
  closeEffect: 'none',
  afterLoad: function () {
    this.width = $(this.element).data('width');
    this.height = $(this.element).data('height');
  },
});

$('#os2-story').click(function () {
  $('html,body').animate(
    {
      scrollTop: $('.os2-story').offset().top,
    },
    'slow'
  );
});

$('#os2-differance').click(function () {
  $('html,body').animate(
    {
      scrollTop: $('.os2-differance').offset().top,
    },
    'slow'
  );
});

$('#os2-team').click(function () {
  $('html,body').animate(
    {
      scrollTop: $('.os2-team').offset().top,
    },
    'slow'
  );
});

$(window).resize(function () {
  var maxHeight = -1;
  var maxHeight1 = -1;
  $('.home-review-desc').each(function () {
    maxHeight =
      maxHeight > $(this).height() ? maxHeight : $(this).height();
  });
  $('.home-review-desc').each(function () {
    $(this).parent().height(maxHeight);
  });
  $('.home-review-title').each(function () {
    maxHeight1 =
      maxHeight1 > $(this).height() ? maxHeight1 : $(this).height();
  });
  $('.home-review-title').each(function () {
    $(this).height(maxHeight1);
  });

  if ($(window).width() > 767) {
    var mtxtH = $('.minsonary-left-top-left.mtext').height();
    var mtxtInner = $(
      '.minsonary-left-top-left.mtext > div'
    ).height();
    var margin = (mtxtH - mtxtInner) / 2;
    $('.minsonary-left-top-left.mtext > div').css(
      'margin-top',
      margin
    );

    var mtxtH2 = $('.minsonary-right-bottom.mtext').height();
    var mtxtInner2 = $(
      '.minsonary-right-bottom.mtext > div'
    ).height();
    var margin2 = (mtxtH2 - mtxtInner2) / 2;
    $('.minsonary-right-bottom.mtext > div').css(
      'margin-top',
      margin2
    );
  }

  $('.gift-row-container .gift-row').each(function () {
    var imgHeight = $(this).find('.row-big').height();
    var rowSmallHeight = $(this).find('.row-small').height();
    var marginTop = (imgHeight - rowSmallHeight) / 2;
    if (marginTop > 1) {
      $(this).find('.row-small').css('margin-top', marginTop);
    } else {
      $(this).find('.row-small').css('margin-top', 20);
    }
  });
});

$(document).ready(function () {
  var maxHeight = -1;
  var maxHeight1 = -1;
  $('.home-review-desc').each(function () {
    maxHeight =
      maxHeight > $(this).height() ? maxHeight : $(this).height();
  });
  $('.home-review-desc').each(function () {
    $(this).parent().height(maxHeight);
  });

  $('.home-review-title').each(function () {
    maxHeight1 =
      maxHeight1 > $(this).height() ? maxHeight1 : $(this).height();
  });
  $('.home-review-title').each(function () {
    $(this).height(maxHeight1);
  });

  $('.home-review-desc a').on('click', function () {
    var obj = $(this).parent();
    var sc = $(this).parent().attr('data-content');
    var sc = decodeURIComponent((sc + '').replace(/\+/g, '%20'));
    obj.html(sc);
    obj.addClass('expanded');

    setTimeout(function () {
      var hh = parseInt(obj.height()) + 10;
      var parentH = parseInt(hh) + 10;
      obj.height(hh);
      obj.parent().height(parentH);
    }, 10);
    //$(this).parent().height(hh);
  });
});

$(function () {
  $('body').click(function () {
    if ($('body').hasClass('home5')) {
      // alert("ar");
      $('body').removeClass('home5');
    }
  });
  //$('.announcement .announcement__inner a').fancybox();

  if ($('.no-title-mens').length) {
    $('#main-nav .mens-menu .menu-collection-item-container li').each(
      function () {
        var aText = $(this)
          .find('.menu-collection-image-title')
          .html();
        var aHref = $(this)
          .find('.menu-collection-image-title')
          .attr('href');

        $(
          '.no-title-mens .sidebar-inner .cat-nav-section.filter-watch-collection ul'
        ).append(
          '<li><a  href="' + aHref + '">' + aText + '</a></li>'
        );
      }
    );

    $('#main-nav .mens-menu .accessories-submenu li').each(
      function () {
        var aLink = $(this).html();
        $(
          '.no-title-mens .sidebar-inner .cat-nav-section.filter-accessories ul'
        ).append('<li>' + aLink + '</li>');
      }
    );
  }

  if ($('.no-title-womens').length) {
    $(
      '#main-nav .womens-menu .menu-collection-item-container li'
    ).each(function () {
      var aText = $(this).find('.menu-collection-image-title').html();
      var aHref = $(this)
        .find('.menu-collection-image-title')
        .attr('href');

      $(
        '.no-title-womens .sidebar-inner .cat-nav-section.filter-watch-collection ul'
      ).append('<li><a href="' + aHref + '">' + aText + '</a></li>');
    });

    $('#main-nav .womens-menu .accessories-submenu li').each(
      function () {
        var aLink = $(this).html();
        $(
          '.no-title-womens .sidebar-inner .cat-nav-section.filter-accessories ul'
        ).append('<li>' + aLink + '</li>');
      }
    );
  }
  if ($('.organised-collection').length) {
    if ($('.no-title-mens').length) {
    } else {
      $(
        '#main-nav .mens-menu .menu-collection-item-container li'
      ).each(function () {
        var aText = $(this)
          .find('.menu-collection-image-title')
          .html();
        var aHref = $(this)
          .find('.menu-collection-image-title')
          .attr('href');

        $(
          '.organised-collection .sidebar-inner .cat-nav-section.filter-watch-collection ul'
        ).append(
          '<li><a href="' + aHref + '">' + aText + '</a></li>'
        );
      });

      $('#main-nav .mens-menu .accessories-submenu li').each(
        function () {
          var aLink = $(this).html();
          $(
            '.organised-collection .sidebar-inner .cat-nav-section.filter-accessories ul'
          ).append('<li>' + aLink + '</li>');
        }
      );
    }
  }

  $('.sidebar-inner .cat-nav-section h3').on('click', function () {
    var sidebarHeight = $('.sidebar-inner').height();
    var sectionHeight = 0;
    var newHeight = 0;
    if ($(this).parent().hasClass('open')) {
      sectionHeight = $(this).parent().height();
      newHeight = sidebarHeight - sectionHeight;
      $(this).parent().removeClass('open');
    } else {
      $(this).parent().addClass('open');
      sectionHeight = $(this).parent().height();
      newHeight = sidebarHeight + sectionHeight;
    }
    //$('.sidebar-inner').css('height', newHeight+"px");
  });

  $('.filter-btn').on('click', function (e) {
    e.preventDefault();
    $('.collection-sidebar').addClass('open');
    /*$('.collection-sidebar').show().addClass('open').animate({right: 0 }, 333);
    $('.mobile-sortby').animate({bottom: -400 }, 333, function() {
      $('.mobile-sortby').hide();
    });*/
  });

  $(document).on('click', function (e) {
    if (
      $(e.target).closest('.collection-sidebar').length === 0 &&
      e.target.className !== 'filter-btn'
    ) {
      if ($('.collection-sidebar').hasClass('open')) {
        $('.close-filter').trigger('click');
      }
    }
  });

  $('.close-filter').on('click', function () {
    $('.collection-sidebar').removeClass('open');
    /*$('.collection-sidebar').removeClass('open').animate({right: -250 }, 333, function() {
      $('.collection-sidebar').hide();
    });*/
  });

  $('.sortby-btn').on('click', function (e) {
    e.stopPropagation();
    $('.mobile-sortby').show().animate({ bottom: 0 }, 333);
  });

  $('.mobile-sortby-close').on('click', function () {
    $('.mobile-sortby').animate({ bottom: -400 }, 333, function () {
      $('.mobile-sortby').hide();
    });
  });

  $('body').click(function (e) {
    if (e.target.className !== 'mobile-sortby-wrapper') {
      $('.mobile-sortby').animate({ bottom: -400 }, 333, function () {
        $('.mobile-sortby').hide();
      });
    }
  });

  $("input[name='sort-by']").change(function () {
    if (this.checked) {
      $("#sort-by option[value='" + $(this).val() + "']").prop(
        'selected',
        true
      );
      $('#sort-by').trigger('change');
      console.log($(this).val());
      $('.mobile-sortby').animate({ bottom: -400 }, 333, function () {
        $('.mobile-sortby').hide();
      });
    }
  });

  $('.cat-nav-subsection h4').on('click', function () {
    $(this).parent().toggleClass('closed').find('ul').slideToggle();
  });

  $('.style-sortby-label').on('click', function () {
    $(this).toggleClass('openeed');
    $(this).parent().find('ul').slideToggle();
  });
});

$(window).on('load', function () {
  var $container = $('.has-sidebar .product-list');
  setTimeout(function () {
    $container.isotope({
      filter: '*',
      animationOptions: {
        duration: 750,
        easing: 'linear',
        queue: false,
      },
    });
  }, 300);

  $('.cat-nav-subsection ul li a').click(function () {
    $(this).toggleClass('active');
    var filters = [];

    $('.cat-nav-subsection ul li a').each(function () {
      if ($(this).hasClass('active')) {
        filters.push($(this).attr('data-filter'));
      }
    });

    filters = filters.join(', ');
    $container.isotope({
      filter: filters,
      animationOptions: {
        duration: 750,
        easing: 'linear',
        queue: false,
      },
    });
    return false;
  });

  $('.mobile-filter-clear-wrapper .clear-btn').on(
    'click',
    function () {
      $('.cat-nav-subsection ul li a').removeClass('active');
      $('.close-filter').trigger('click');
      $container.isotope({
        filter: '*',
        animationOptions: {
          duration: 750,
          easing: 'linear',
          queue: false,
        },
      });
      return false;
    }
  );

  $('.mobile-filter-clear-wrapper .apply-btn').on(
    'click',
    function () {
      $('.close-filter').trigger('click');
    }
  );
});

$(window).resize(function () {
  var $container = $('.has-sidebar .product-list');
  $container.isotope({
    filter: '*',
    animationOptions: {
      duration: 750,
      easing: 'linear',
      queue: false,
    },
  });
});

// $(document).ready(function(){
//   /*---------------*/
//   if($('.collection-sidebar').length){

//     //var length =  $('.product-list').height() ;
//     var topheight;

//     if($('.breadcrumb').length){
//       topheight = "0px";
//     }else{
//       topheight = '70px';
//     }

//     $(window).scroll(function () {
//       var length = $('.collection-sidebar').height() - $('.sidebar-inner').height() + $('.collection-sidebar').offset().top-150;
//       if($(window).width() > 768){
//         //var mHeight = 30;
//         var mHeight = 150;
//         if($('.sidebar-inner').height() > $(window).height()){
//           mHeight = $('.sidebar-inner').height() - $(window).height();
//         }
//         var scroll = $(this).scrollTop();
//         var height = $('.sidebar-inner').height() + 'px';
//         if (scroll < $('.collection-sidebar').offset().top - mHeight) {
//           //console.log("aaa- "+mHeight + "---" + scroll);
//           $('.sidebar-inner').css({
//             'position': 'absolute',
//             'top': topheight
//           });

//         } else if (scroll >= length) {
//           //console.log("bbb- "+mHeight + "---" + scroll);
//           $('.sidebar-inner').css({
//             'position': 'absolute',
//             'bottom': '0',
//             'top': 'auto'
//           });
//         } else {
//           //console.log("ccc- "+mHeight + "---" + scroll);
//           $('.sidebar-inner').css({
//             'position': 'fixed',
//             'top': mHeight,
//             'height': height
//           });

//         }
//       }
//     });

//     if($(window).width() > 768){

//       var cHeight = $('.sidebar-inner').height();
//       console.log(cHeight);
//       $('.collection-right.has-sidebar .collection-listing').css('min-height', cHeight+ 100);

//       //console.log("length- "+length)
//       var scroll = $(window).scrollTop();
//       var height = $('.sidebar-inner').height() + 'px';
//       if (scroll < $('.collection-sidebar').offset().top) {
//         $('.sidebar-inner').css({
//           'position': 'absolute',
//           'top': topheight
//         });
//       } else if (scroll >= length) {
//         $('.sidebar-inner').css({
//           'position': 'absolute',
//           'bottom': '0',
//           'top': 'auto'
//         });
//       } else {
//         //console.log("height- "+height);
//         $('.sidebar-inner').css({
//           'position': 'fixed',
//           'top': '70px',
//           'height': height
//         });
//       }
//     }
//   }
//   /*---------------*/

// });

$(window).resize(function () {
  if ($(window).width() > 768) {
    var cHeight = $('.sidebar-inner').height();
    $('.collection-right.has-sidebar .collection-listing').css(
      'min-height',
      cHeight + 100
    );
  }
});

$(document).ready(function () {
  if ($(window).width() < 769) {
    startCarousel();
  } else {
    $('.blog-tab').addClass('off');
  }
  $('.close_announcement').on('click', function () {
    $(this).parent().toggleClass('hide_the_anouncement');
  });
  setTimeout(function () {
    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    var reviewCount = $('.home-review-count .text-m')
      .text()
      .replace('Reviews', '')
      .replace(' ', '');
    $('.home_review_count').text(numberWithCommas(reviewCount));
  }, 500);
});

$(window).resize(function () {
  if ($(window).width() < 769) {
    startCarousel();
  } else {
    stopCarousel();
    $('.blog-tab .tab-item:first').addClass('current');
  }
});

function startCarousel() {
  var owl = $('.blog-tab');
  owl.owlCarousel({
    center: true,
    items: 3,
    loop: false,
    margin: 0,
    nav: true,
    navText: [
      '<i class="fa fa-angle-left"></i>',
      '<i class="fa fa-angle-right"></i>',
    ],
    navElement: 'div',
    dots: false,
    loadedClass: 'owl-carousel',
  });
  owl.on('changed.owl.carousel', function (event) {
    var current = event.item.index;
    var tag = $(event.target)
      .find('.owl-item')
      .eq(current)
      .find('.tab-item')
      .attr('data-tag');

    $('.blog-tab .tab-item').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $('#' + tag).addClass('current');
  });

  $(document).on(
    'click',
    '.blog-tab.owl-carousel .tab-item',
    function () {
      var positionIndex = parseInt($(this).data('position') - 1);
      owl.trigger('to.owl.carousel', positionIndex);
    }
  );
}
function stopCarousel() {
  var owl = $('.blog-tab');
  owl.trigger('destroy.owl.carousel');
  owl.addClass('off');
}
//console.log('hello world');

if ($(window).width() > 768) {
  var itemtoshow = 3;
} else {
  var itemtoshow = 1;
}

/*if(sllickItem > itemtoshow){
  var cart_also_bought = $("#cart-alsobought");
  cart_also_bought.slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: '<div class="slick-next"><i class="fa fa-angle-right"></i></div>',
    prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left"></i></div>',
    responsive: [
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
*/

$('.mobile-pg').click(function (e) {
  e.preventDefault();
  $(this).prev('.our-story-block-content').removeClass('mobile-min');
  $(this).addClass('hide');
});

$('body').on('click', '.story-tab-exe ul li', function () {
  console.log('111');
  $('.story-tab-exe ul li').removeClass('active');
  $(this).addClass('active');
  var id = $(this).attr('data-tab');
  var topx = 0;
  if (id == 'our-story') {
    topx = 160;
  } else if (id == 'our-process') {
    topx = 140;
  } else if (id == 'meet-the-team') {
    topx = 80;
  }
  if (id == 'stories') {
    topx = 250;
  } else if (id == 'partnerships') {
    topx = 250;
  } else if (id == 'climate') {
    topx = 250;
  } else if (id == 'loyalty') {
    topx = 250;
  } else if (id == 'mission') {
    topx = -180;
  }

  $('html,body').animate(
    {
      scrollTop: $('#' + id).offset().top - topx,
    },
    'slow'
  );
});

window.onscroll = function () {
  if ($('.story-tab-heading').length) {
    stack_story_tab();
    change_story_heading();
  }
};

if ($('.story-tab-heading').length) {
  var navbar = document.querySelector('.story-tab-heading');
  var our_story_top = document.querySelector('.our-story-section');
  var our_process_top = document.querySelector(
    '.our-process-section'
  );
  var meet_team_top = document.querySelector('.meet-team-section');
  var sticky = navbar.offsetTop;
}

function stack_story_tab() {
  if (window.pageYOffset >= sticky) {
    navbar.classList.add('sticky');
    $('body').addClass('story-tab-sticky');
    $('.story-tab-heading').css('opacity', '0');
    var htmlx = $('.story-tab-heading').html();
    if (!$('.story-tab-heading2').length) {
      $('#shopify-section-header').after(
        "<div id='story-tab-heading' class='story-tab-heading2 story-tab-exe'>" +
          htmlx +
          '</div>'
      );
    }
  } else {
    navbar.classList.remove('sticky');
    $('body').removeClass('story-tab-sticky');
    $('.story-tab-heading').css('opacity', '1');
    $('.story-tab-heading2').remove();
  }
}

function change_story_heading() {
  var topx = window.pageYOffset + 100;
  var topy = our_process_top.offsetTop - 200;
  if (topx >= meet_team_top.offsetTop) {
    $('.story-tab-exe ul li').removeClass('active');
    $('.story-tab-exe ul li[data-tab="meet-the-team"]').addClass(
      'active'
    );
  } else if (topx >= topy) {
    $('.story-tab-exe ul li').removeClass('active');
    $('.story-tab-exe ul li[data-tab="our-process"]').addClass(
      'active'
    );
  } else if (topx >= our_story_top.offsetTop) {
    $('.story-tab-exe ul li').removeClass('active');
    $('.story-tab-exe ul li[data-tab="our-story"]').addClass(
      'active'
    );
  } else {
  }
}

$('.process-small-block-container-inner').slick({
  centerMode: false,
  centerPadding: '0px',
  slidesToShow: 5,
  dots: false,
  responsive: [
    {
      breakpoint: 769,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '80px',
        slidesToShow: 2,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '80px',
        slidesToShow: 1,
        dots: true,
      },
    },
  ],
});

$('.play-btn').click(function (e) {
  e.preventDefault();
  var src1 = $(this).data('src');
  $('.modal-content iframe').attr('src', src1);
  $('#myModal').show();
  var w_height = $(window).height();
  var modal_height = $('.modal-content').height();
  var margin = (w_height - modal_height) / 2;
  $('.modal-content').css('margin-top', margin);
});

$(window).on('load', function () {
  if (window.location.hash) {
    var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
    //alert(hash);
    if (hash == 'our-process-section') {
      setTimeout(function () {
        $('html, body').animate({
          scrollTop: $('#our-process').offset().top - 150,
        });
        //$('.story-tab-exe ul li[data-tab="our-process"]').trigger('click');
      }, 1000);
    }
  }
});

$(document).ready(function () {
  if ($(window).width() >= 768) {
    $('.link-container').hover(
      function () {
        $(this).addClass('hover');
        var heights = $('.link-container ul')
          .map(function () {
            return $(this).outerHeight();
          })
          .get();
        var maxHeight = Math.max.apply(null, heights);
        console.log(maxHeight);
        $('.link-container .hide-link').css('height', 'auto');
      },
      function () {
        $(this).removeClass('hover');
        $('.link-container .hide-link').removeAttr('style');
      }
    );
  }
  if ($(window).width() < 768) {
    $('.link-container .home-links-header').click(function () {
      if (!$(this).parent().find('ul').hasClass('open')) {
        $('.link-container ul.open').removeClass('open').slideUp();
      }
      $(this).parent().find('ul').toggleClass('open').slideToggle();
    });
  }

  /*------ custom description tab-----------*/

  $('.custom-desc-tab li').click(function () {
    $('.custom-desc-tab li').removeClass('active-link');
    $(this).addClass('active-link');

    var activeTab = $(this).attr('data-tab');
    $('.custom-desc-tab-content > div').removeClass('active-tab');
    $('.custom-desc-tab-content > div.' + activeTab).addClass(
      'active-tab'
    );
  });

  /*------ custom description accordion - LEGACY: New code in sections/product-details.liquid -----------*/
   // $('.custom-desc-accodian li .accordian-title').click(function(){
   // 	//$('.custom-desc-accodian li').removeClass('active-link');
   //   $(this).parent().find('.accordian-content').slideToggle(function(){
   //   	$(this).parent().toggleClass('active-link');
   //   });
   // });

  $('a.custom-pop-new').click(function (e) {
    e.preventDefault();
    $('.custom-pop-content-main').toggle();
  });
  $('.custom-pop-content-wrap span.close_button').click(function (e) {
    e.preventDefault();
    $('.custom-pop-content-main').hide();
  });

  $('.mobile-search-opener').click(function () {
    if ($(this).hasClass('search-open')) {
      $(this).removeClass('search-open');
      $('.mobile-search').removeClass('search-open');
      $('body').removeClass('search-opened');
    } else {
      $(this).addClass('search-open');
      $('.mobile-search').addClass('search-open');
      $('body').addClass('search-opened');
    }
  });
  $('.mobile-nav-toggle').click(function (e) {
    e.preventDefault();

    //var headerHeight = $('.mobile-menu-wrapper').offset().top;
    //var heightmeasure = 'calc(100vh - '+ headerHeight+'px';

    var heightmeasure = '';
    if ($('#shopify-section-header').hasClass('sticky')) {
      var headerHeight = $('#shopify-section-header').height();
      heightmeasure = 'calc(100vh - ' + headerHeight + 'px';
    } else {
      var headerHeight = $('.mobile-menu-wrapper').offset().top;
      heightmeasure = 'calc(100vh - ' + headerHeight + 'px';
    }

    if ($('body').hasClass('reveal-mobile-nav')) {
      $('body').removeClass('reveal-mobile-nav');
      $('ul.top-ul').removeAttr('height');
    } else {
      $('body').addClass('reveal-mobile-nav');
      $('.mobile-nav-subcontainer').css('height', heightmeasure);
      $('ul.top-ul').css('height', heightmeasure);
    }
    if ($('.mobile-search-opener').hasClass('search-open')) {
      $('.mobile-search-opener').removeClass('search-open');
      $('.mobile-search').removeClass('search-open');
    }
  });
  $('.mobile-nav-toggle').click(function (e) {
    e.preventDefault();

    //var headerHeight = $('.mobile-menu-wrapper').offset().top;
    //var heightmeasure = 'calc(100vh - '+ headerHeight+'px';

    var heightmeasure = '';
    if ($('#shopify-section-header').hasClass('sticky')) {
      var headerHeight = $('#shopify-section-header').height();
      heightmeasure = 'calc(100vh - ' + headerHeight + 'px';
    } else {
      var headerHeight = $('.mobile-menu-wrapper').offset().top;
      heightmeasure = 'calc(100vh - ' + headerHeight + 'px';
    }

    if ($('body').hasClass('reveal-mobile-nav')) {
      $('body').removeClass('reveal-mobile-nav');
      $('ul.top-ul').removeAttr('height');
    } else {
      $('body').addClass('reveal-mobile-nav');
      $('.mobile-nav-subcontainer').css('height', heightmeasure);
      $('ul.top-ul').css('height', heightmeasure);
    }
    if ($('.mobile-search-opener').hasClass('search-open')) {
      $('.mobile-search-opener').removeClass('search-open');
      $('.mobile-search').removeClass('search-open');
    }
  });

  $('.blog-header .mobile-nav-open').on('click', function (e) {
    e.preventDefault();

    var heightmeasure = '';
    if ($('#shopify-section-header').hasClass('sticky')) {
      var headerHeight = $('#shopify-section-header').height();
      heightmeasure = 'calc(100vh - ' + headerHeight + 'px';
      //$('.blog-navigation').css('top', headerHeight);
    } else {
      var headerHeight = $('.blog-nav-row').offset().top + 48;
      heightmeasure = 'calc(100vh - 38px';
      //$('.blog-navigation').css('top', headerHeight);
    }

    if ($('body').hasClass('reveal-mobile-nav')) {
      $('.blog-navigation').removeClass('open');
      $('body').removeClass('reveal-mobile-nav');
    } else {
      $('.blog-navigation').addClass('open');
      //$('.blog-navigation').css('height', heightmeasure);
      $('body').addClass('reveal-mobile-nav');
    }
  });

  $('#blog-main-nav li.mobile-menu-header a').on(
    'click',
    function (e) {
      e.preventDefault();
      console.log('hello world');
      $('.blog-header .mobile-nav-open').trigger('click');
    }
  );
  $('#content, #pagefooter').on('click', function (event) {
    if ($('body').hasClass('reveal-mobile-nav')) {
      $('.blog-header .mobile-nav-open').trigger('click');
    }
  });
  $(window).scroll(function (event) {
    if ($('body').hasClass('reveal-mobile-nav')) {
      $('.blog-header .mobile-nav-open').trigger('click');
    }
  });

  $('.collection-faq-list .faq-item .faq-question').on(
    'click',
    function () {
      //$(this).parent().find('.faq-answer').slideToggle();
      $(this).parent().toggleClass('open');
    }
  );
});

$(document).ready(function () {
  /*============= gift wrap add to cart in cart page ===============*/
  $('#giftwrap_cart').on('click', function () {
    if ($(this).prop('checked') == true) {
      var giftProductId = $(this).val();
      $.ajax({
        url: '/cart/add.js',
        data: { 'id[]': giftProductId },
        type: 'post',
        dataType: 'json',
        success: function (itemData) {
          location.reload();
        },
      });
    }
  });
});

/*--------------------- for ambassador details page --------------*/
if ($('#profile_content_slider').length) {
  $('#profile_content_slider').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: '<div class="slick-next"></div>',
    prevArrow: '<div class="slick-prev"></div>',
    responsive: [
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}
